import React from 'react';
import { Box } from '@mui/material';
import SessionStatisticsChart from '../SessionStatisticsChart';
import PlanQuotasCard from '../cards/PlanQuotasCard';
import '../styles/ContentComponents.css';

function General() {
  return (
    <Box sx={{ width: '100%', minHeight: '100vh', py: 4 }}>
      <Box sx={{ maxWidth: 1100, mx: 'auto', px: { xs: 1, sm: 2 }, width: '100%' }}>

        {/* Plan entitlements — what each subscription plan allows */}
        <PlanQuotasCard />

        {/* Session Statistics Chart */}
        <SessionStatisticsChart />
      </Box>
    </Box>
  );
}

export default General;
